import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import React, { useState } from 'react';

export default function DeleteCouponDialog({
  onDeleteButtonClicked,
  selectedCoupons,
  open,
  handleClose,
}) {
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const openConfirmDialog = () => {
    setConfirmDialogOpen(true);
  };
  const closeConfirmDialog = () => {
    setConfirmDialogOpen(false);
  };
  return (
    <>
      <Dialog
        onClose={handleClose}
        aria-labelledby='simple-dialog-title'
        open={open}
      >
        <DialogTitle id='simple-dialog-title'>Delete Coupon</DialogTitle>
        <DialogContent>
          <DialogContentText style={{ marginBottom: '12px' }}>
            The following coupons will be deleted:
          </DialogContentText>
          <div className='grid grid-cols-2 gap-2'>
            {selectedCoupons?.map((coupon, i) => {
              return (
                <div
                  className='px-3 py-1.5 rounded-md text-sm font-medium'
                  key={i}
                  style={{
                    backgroundColor: 'var(--status-error-bg)',
                    color: 'var(--status-error-text)',
                  }}
                >
                  {coupon.couponCode}
                </div>
              );
            })}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color='primary' variant='text'>
            Cancel
          </Button>
          <Button
            onClick={openConfirmDialog}
            variant='contained'
            style={{ backgroundColor: '#EF4444', color: '#fff' }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog onClose={closeConfirmDialog} open={confirmDialogOpen}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete these coupons? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeConfirmDialog} color='primary' variant='text'>
            Cancel
          </Button>
          <Button
            onClick={onDeleteButtonClicked}
            variant='contained'
            style={{ backgroundColor: '#EF4444', color: '#fff' }}
          >
            Yes, Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
